export const SUPPRESSED_WARNINGS = [
    'NO_GOOGLE_ANALYTICS_REFRESH_TOKEN_ERROR',
    'ANALYTICS_ACCOUNT_NOT_FOUND_ERROR',
];
